export default function MobileMenu() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const toggle = header.querySelector('.site-header__wrapper-toggle');
    const drawer = header.querySelector('.site-header__drawer');
    const nav = header.querySelector('.site-header__wrapper-nav');
    if (!toggle || !drawer || !nav || typeof drawer.showModal !== 'function') return;

    const close = drawer.querySelector('.site-header__drawer-close');
    const wrapper = header.querySelector('.site-header__wrapper');
    const mobile = window.matchMedia('(max-width: 650px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame = 0;
    let closeTimer = 0;
    let closing = false;

    const reset = () => {
        window.cancelAnimationFrame(frame);
        window.clearTimeout(closeTimer);
        drawer.classList.remove('site-header__drawer-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('site-menu-open');
        closing = false;
    };

    const finishClose = () => {
        if (drawer.open) drawer.close();
        reset();
    };

    const requestClose = () => {
        if (!drawer.open || closing) return;
        window.cancelAnimationFrame(frame);
        closing = true;
        drawer.classList.remove('site-header__drawer-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (reducedMotion.matches) {
            finishClose();
            return;
        }
        closeTimer = window.setTimeout(finishClose, 360);
    };

    const sync = () => {
        finishClose();
        toggle.hidden = !mobile.matches;
        (mobile.matches ? drawer : wrapper).appendChild(nav);
    };

    toggle.addEventListener('click', () => {
        if (!mobile.matches || drawer.open) return;
        reset();
        document.documentElement.classList.add('site-menu-open');
        drawer.showModal();
        drawer.scrollTop = 0;
        toggle.setAttribute('aria-expanded', 'true');
        close.focus({ preventScroll: true });
        frame = window.requestAnimationFrame(() => {
            frame = window.requestAnimationFrame(() => {
                if (drawer.open && !closing) drawer.classList.add('site-header__drawer-open');
            });
        });
    });

    close.addEventListener('click', requestClose);
    drawer.addEventListener('cancel', (event) => {
        event.preventDefault();
        requestClose();
    });
    drawer.addEventListener('close', reset);
    drawer.addEventListener('transitionend', (event) => {
        if (closing && event.target === drawer && event.propertyName === 'transform') finishClose();
    });
    drawer.addEventListener('click', (event) => {
        if (event.target !== drawer) return;
        const bounds = drawer.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            requestClose();
        }
    });
    nav.addEventListener('click', (event) => {
        if (event.target.closest('a')) requestClose();
    });
    mobile.addEventListener('change', sync);
    window.addEventListener('pagehide', finishClose);
    sync();
}
